import React, { ReactElement } from 'react';
import { Tooltip } from '@chakra-ui/react';
import 'moment/locale/is';
import { useNavigate } from 'react-router-dom';
import { IconEdit } from 'components/Icons';

interface ActionsCellProps {
  id: number;
  role: string;
  statusName: string;
  adminPath: string;
}

export const ActionsCell: React.FC<ActionsCellProps> = ({
  id,
  role,
  statusName,
  adminPath,
}) => {
  const navigate = useNavigate();

  const renderActionItem = (status: string): ReactElement<any, any> | null => {
    switch (status) {
      case 'DRAFT':
        return (
          <Tooltip label="Breyta upplýsingum">
            <IconEdit
              cursor="pointer"
              onClick={(): void =>
                navigate(`${adminPath}/ferdabeidnir/ferdabeidni?id=${id}`)
              }
            />
          </Tooltip>
        );
      case 'PENDING':
      case 'DENIED':
        return (
          <Tooltip label={role ? 'Samþykkja beiðni' : 'Skoða beiðni'}>
            <IconEdit
              cursor="pointer"
              onClick={(): void =>
                navigate(
                  `${adminPath}/ferdabeidnir/ferdabeidni/preview?id=${id}&action=beidni&role=approver`,
                  {
                    state: { hasActions: !!role, role },
                  }
                )
              }
            />
          </Tooltip>
        );
      case 'COST_APPROVED':
        return (
          <Tooltip label={role ? 'Samþykkja beiðni' : 'Skoða beiðni'}>
            <IconEdit
              cursor="pointer"
              onClick={(): void =>
                navigate(
                  `${adminPath}/ferdabeidnir/ferdabeidni/preview?id=${id}&action=beidni`,
                  {
                    state: { hasActions: !!role, role },
                  }
                )
              }
            />
          </Tooltip>
        );
      case 'AUTHORIZED':
        return (
          <Tooltip label="Breyta skráningu ferðabeiðnar">
            <IconEdit
              cursor="pointer"
              onClick={(): void =>
                navigate(
                  `${adminPath}/ferdabeidnir/ferdabeidni/preview?id=${id}&action=beidni&edit=true`,
                  {
                    state: { hasActions: true },
                  }
                )
              }
            />
          </Tooltip>
        );
      case 'COST_REVISIT':
        return (
          <Tooltip label="Skrá kostnaðarliði">
            <IconEdit
              cursor="pointer"
              onClick={(): void =>
                navigate(
                  `${adminPath}/ferdabeidnir/ferdabeidni/preview?id=${id}&action=kostnadur`,
                  {
                    state: { hasActions: true },
                  }
                )
              }
            />
          </Tooltip>
        );
      case 'COST_IN_REVIEW':
      case 'COST_REVIEWED':
        return (
          <Tooltip label="Skoða beiðni">
            <IconEdit
              cursor="pointer"
              onClick={(): void =>
                navigate(
                  `${adminPath}/ferdabeidnir/ferdabeidni/preview?id=${id}&action=beidni`,
                  {
                    state: { hasActions: true },
                  }
                )
              }
            />
          </Tooltip>
        );
      case 'COST_CONFIRMED':
        return (
          <Tooltip label={role ? 'Samþykkja kostnað' : 'Skoða beiðni'}>
            <IconEdit
              cursor="pointer"
              onClick={(): void =>
                navigate(
                  `${adminPath}/ferdabeidnir/ferdabeidni/preview?id=${id}&action=beidni`,
                  {
                    state: { hasActions: !!role, role },
                  }
                )
              }
            />
          </Tooltip>
        );
      case 'COMPLETED':
        return (
          <Tooltip label="Skoða beiðni">
            <IconEdit
              cursor="pointer"
              onClick={(): void =>
                navigate(
                  `${adminPath}/ferdabeidnir/ferdabeidni/preview?id=${id}&action=beidni`,
                  {
                    state: { hasActions: false },
                  }
                )
              }
            />
          </Tooltip>
        );
      default:
        return null;
    }
  };
  return renderActionItem(statusName);
};
